import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getMatchTeams, getMatchTennisDouble } from 'reducers/index';
import TennisDouble from './tennisDouble/TennisDouble';
import TennisSingle from './tennisSingle/TennisSingle';

const mapStateToProps = ((state, ownProps) => ({
  tennisDouble: getMatchTennisDouble(state, ownProps.matchId),
  teams: getMatchTeams(state, ownProps.matchId),
}));

const Tennis = ({
  matchId, tennisDouble, teams,
}) => {
  let tennisComponent;

  if (tennisDouble) {
    tennisComponent = <TennisDouble matchId={matchId} competitors={tennisDouble} />;
  } else if (teams) {
    tennisComponent = <TennisSingle matchId={matchId} competitors={teams} />;
  }

  return (
    <div className={'z-10 flex flex-col'}>
      {tennisComponent}
    </div>
  );
};

Tennis.propTypes = {
  matchId: PropTypes.number.isRequired,
  tennisDouble: PropTypes.object,
  teams: PropTypes.shape({
    home: PropTypes.array,
    away: PropTypes.array,
  }),
};

Tennis.defaultProps = {
  tennisDouble: null,
  teams: {
    home: [{ name: '', abbr: '' }],
    away: [{ name: '', abbr: '' }],
  },
};

export default connect(mapStateToProps)(Tennis);
